import {
	DropDownButton,
	DropDownWithIcon,
	Icon,
	QueryStateIndicators,
	Tooltip,
} from "@components";
import React, { useContext } from "react";
import { Alert } from "react-bootstrap";
import { useAsyncCommand, useDialog, useServices } from "@hooks";
import { defer } from "@util/helpers";
import { ModuleSetting } from "@models";
import { alertStyle } from "@components/ErrorAlert";
import ProductsPageContext from "../ProductsPageContext";

type Props = {
	moduleSetting: ModuleSetting;
};

export default function ModuleSettingControlsDropdown(props: Props) {
	const pageContext = useContext(ProductsPageContext);
	const { productService } = useServices();
	const [deleteModuleSettingFn, deleteQueryResult] = useAsyncCommand(
		() =>
			productService.deleteModuleSetting(props.moduleSetting.moduleSettingId),
		{ rethrowError: false }
	);

	const deleteProductDialog = useDialog();
	const onSelectDeleteModuleSetting = () => {
		deleteProductDialog.showConfirmDialog({
			title: "Produkt löschen",
			content:
				"Produkt wirklich löschen? Wenn schon Belege hochgeladen wurden, wird empfohlen, stattdessen das Budget zeitlich zu begrenzen. Andernfalls wird die Verbindung der Belege zum Budget getrennt. Guthaben aus bestehenden Guthabenkonten gehen verloren. Das Budget kommt nicht mehr in Buchungslisten vor.",
			confirmText: "Löschen",
			onConfirm: async () => {
				const result = await deleteModuleSettingFn();
				if (result.state === "success") {
					await defer(() => pageContext.triggerRefresh());
				}
			},
		});
	};

	return (
		<>
			<DropDownButton
				variant="outline-primary"
				id="moduleSettingControlsDropdown"
				title={
					<Tooltip
						id="moduleSettingControlsDropdownButton"
						tooltip={"Einstellungen"}
					>
						<Icon.Settings />
					</Tooltip>
				}
				size="sm"
				onClick={(e: React.MouseEvent) => {
					e.stopPropagation();
					e.preventDefault();
				}}
			>
				<DropDownWithIcon
					onSelect={onSelectDeleteModuleSetting}
					className="danger"
				>
					<Icon.Delete />
					<span>Löschen</span>
				</DropDownWithIcon>
			</DropDownButton>
			<QueryStateIndicators queryState={deleteQueryResult} />

			{deleteQueryResult.state === "success" && (
				<Alert style={alertStyle} variant="success">
					Moduleinstellung erfolgreich gelöscht
				</Alert>
			)}
		</>
	);
}
